"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setIntrospectionEnabled = exports.isIntrospectionEnabled = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var usesIntrospection = _propTypes.default.any.__INTROSPECTION__;
/**
 * @return {boolean}
 */

var isIntrospectionEnabled = function isIntrospectionEnabled() {
  return usesIntrospection;
};
/**
 * Override for testing logic dependent on isIntrospectionEnabled()
 * @param {boolean} newUsesIntrospection
 */


exports.isIntrospectionEnabled = isIntrospectionEnabled;

var setIntrospectionEnabled = function setIntrospectionEnabled(newUsesIntrospection) {
  usesIntrospection = newUsesIntrospection;
};

exports.setIntrospectionEnabled = setIntrospectionEnabled;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.3729/js/utils/propTypes/internal/introspection.js
// module id = 345
// module chunks = 209 210 211 212